import { centralizedApiCalling } from "./centralizedApiCalling";

const userAuthApi = process.env.REACT_APP_AUTH_API_URL;
const dailySalesBaseApi = process.env.REACT_APP_BASE_DAILYSALES;
const coreBaseApi = process.env.REACT_APP_BASE_CORE;
const useridAPI = process.env.REACT_APP_USER;
const preferenceAPI = process.env.REACT_APP_USER_PREFERENCES;
const securityApi = process.env.REACT_APP_USER_SECURITY;
const stagingcoreBaseApi = process.env.REACT_APP_STAGING_BASE_CORE;

const OpenAuthorization = false;

export const authIDTemp = async () => {
  const body = {
    userName: "Ajay@nimbleaccounting.com",
    password: "Ajay@123",
    // "url": "das"
    url: "qa17",
  };
  const data = await centralizedApiCalling(
    `${userAuthApi}/Login`,
    "POST",
    body,
    OpenAuthorization
  );
  return data.data.authID;
};
export const login = async (payload) => {
  const response = await fetch(
    "https://qa-api-usermgmt.nimbleproperty.net/v1/OpenApiauth/Login",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );

  if (!response.ok) throw new Error("Login failed");

  const id = await response.json();
  return id.authID;
  // return response
};

export const exchangeToken = async (url, authID) => {
  const body = { token: authID };
  const data = await centralizedApiCalling(
    `${userAuthApi}/${url}/OpenApiauth/ExchangeOAuth`,
    "POST",
    body,
    OpenAuthorization
  );

  return data;
};

export const refreshToken = async (token, url, refAuthID) => {

  const body = { refAuthID };
  const data = await centralizedApiCalling(
    `${userAuthApi}/${url}/OpenApiauth/RefreshToken`,
    "POST",
    body,
  );

  return {
    token: data?.data?.token,
    minutesToExpire: data?.data?.minutesToExpire,
    refAuthID: data?.data?.refAuth,
  };
}



export const getCorporations = async () => {
  const body = { IsShowAll: false };
  const data = await centralizedApiCalling(
    `${coreBaseApi}/corporations`,
    "GET",
    body
  );
  const corporations = data.data.Corporations;
  const setSelect = {
    ID: "select",
    Name: "-Select Corporation-",
    LegalName: "-Select Corporation-",
  };
  corporations.unshift(setSelect);
  return corporations;
};

export const getPCS = async (CorpID) => {
  const body = { CorpID };
  const data = await centralizedApiCalling(`${coreBaseApi}/pcs`, "GET", body);
  const pcsList = data.data?.ListInfo;
  const setSelect = { ID: "select", Name: "-Select-" };
  pcsList.unshift(setSelect);
  return pcsList;
};
export const accounts = async (accId, CorpID) => {
  const body = { AccountTypeID: accId, IsInactive: false, CorpID };
  const data = await centralizedApiCalling(
    `${coreBaseApi}/accounts`,
    "GET",
    body
  );
  const accList = data.data.Accounts;
  const setSelect = { ID: "select", Name: "Select account" };
  accList.unshift(setSelect);
  return accList;
};

export const GetDailyConfigAccounts = async (body) => {
  const data = await centralizedApiCalling(
    `${dailySalesBaseApi}/GetDailyConfigAccounts`,
    "POST",
    body
  );
  const coaList = data.data.configuredAccounts;
  const setSelect = { AccountID: "select", AccountName: "Select account" };
  coaList.unshift(setSelect);
  return coaList;
};
export const getDailyConfigCardTypes = async () => {
  const data = await centralizedApiCalling(
    `${dailySalesBaseApi}/GetDailyConfigCardTypes`,
    "POST"
  );
  return data.data.CardsList;
};

export const getUserid = async () => {
  const data = await centralizedApiCalling(
    `${useridAPI}/user/GetUserDetails`,
    "POST"
  );

  return data.data.userID;
};
export const Previlages = async (userId, menuId, optionalMenuId) => {
  const body = { UserID: userId, MenuIds: `${menuId}${optionalMenuId ? `,${optionalMenuId}` : ""}` };
  const data = await centralizedApiCalling(
    `${coreBaseApi}/Previlages`,
    "POST",
    body
  );

  return data.data.Details;
};
export const userPref = async (userId) => {
  const body = { UserID: userId };
  const data = await centralizedApiCalling(
    `${preferenceAPI}UserPreferences`,
    "POST",
    body
  );
  return data.data;
};
export const userSecurity = async (payload) => {
  const data = await centralizedApiCalling(
    `${securityApi}CorporationLockCheck`,
    "POST",
    payload
  );


  // return data.data;
  return data.data;
};

export const unlockSecurity = async (CorpID, Password) => {
  const data = await centralizedApiCalling(
    `${securityApi}ValidatePassword?CorpID=${encodeURIComponent(
      CorpID
    )}&Password=${encodeURIComponent(Password)}`,
    "GET"
  );


  return data;
};

// export const userApproval = async () => {
//   const data = await centralizedApiCalling(
//     `${coreBaseApi}/GetUserApprovalType`,
//     "GET"
//   );
//   // return data.data;
//   return data.data;
// };

export const userApproval = async () => {
  const phaseResponse = await centralizedApiCalling(
    `${coreBaseApi}/IsAPFourthPhaseEnabled`,
    "POST"
  );

  const isFourthPhaseEnabled = phaseResponse?.data ?? phaseResponse;

  const baseApi = isFourthPhaseEnabled
    ? coreBaseApi
    : stagingcoreBaseApi;

  const data = await centralizedApiCalling(
    `${baseApi}/GetUserApprovalType`,
    "GET",
    {
      TransactionType: 154,
    }
  );

  return data.data;
};

